
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Spinner,
    Button
} from 'reactstrap';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { apiURL1 } from '../../config';
import Header from '../../components/Headers/Header';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import './ViewExam.css';
import Footer from 'components/Footers/Footer';
const baseURL = apiURL1; // Replace with your actual base URL

function ViewExam() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [exam, setExam] = useState(null);
    const [loading, setLoading] = useState(true);
    const [schoolInfo, setSchoolInfo] = useState({});
    const token = localStorage.getItem("token");


    const componentRef = useRef();

    useEffect(() => {
        fetchExam();
        fetchSchoolInfo();
    }, [id]);


    const fetchSchoolInfo = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/school-settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            });
            if (response.data && response.data.length > 0) {
                setSchoolInfo(response.data[0]);
            }
        } catch (error) {
            console.error('Error fetching school info:', error);
        }
    };


    const generateExamSlip = async () => {
        const pdf = new jsPDF();

        // Add School Logo and Info
        try {

            const imgData = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";
            pdf.addImage(imgData, 'PNG', 10, 10, 30, 30);
        } catch (error) {
            console.error('Error loading logo:', error);
        }

        pdf.setFontSize(16);
        pdf.text(schoolInfo.schoolName || 'Ummu Dhardha Ladies Islamic College', 50, 15);
        pdf.setFontSize(12);
        pdf.text(schoolInfo.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.', 50, 22);
        pdf.text(`Tel: ${schoolInfo.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${schoolInfo.schoolEmail || 'info@ummudhardha.lk'}`, 50, 28);

        // Exam Details
        pdf.setFontSize(14);
        pdf.text('Exam Details', 10, 50); // Adjusted Y position
        pdf.text(`Class: ${exam.class.className}`, 10, 58); // Adjusted Y position
        pdf.text(`Course: ${exam.course.courseName}`, 10, 66); // Adjusted Y position
        pdf.text(`Type: ${exam?.type?.name}`, 10, 74); // Adjusted Y position
        pdf.text(`Year: ${exam.year}`, 10, 82); // Adjusted Y position
        pdf.text(`Status: ${exam.status}`, 10, 90); // Adjusted Y position

        const tableData = exam.examDetails.map(detail => [
            detail.subject.subjectCode,
            detail.subject.name,
            detail.teacher ? detail.teacher.name : 'N/A',
            dayjs(detail.examDate).format('DD-MM-YYYY'),
            detail.startTime,
            detail.endTime
        ]);

        pdf.autoTable({
            head: [['Subject Code', 'Subject', 'Staff', 'Date', 'Start Time', 'End Time']],
            body: tableData,
            startY: 100, // Adjusted Y position
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 }
        });

        pdf.save(`exam-details-${exam.class.className}-${exam.course.courseName}.pdf`);
    };

    const loadImage = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            img.onerror = reject;
            img.src = url;
        });
    };

    const handlePrint = () => {
        const tableStyle = `
      border-collapse: collapse;
      width: 100%;
      margin-top: 20px;
    `;

        const thStyle = `
      background-color: #2980b9;
      color: white;
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    `;

        const tdStyle = `
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    `;

        const printContent = `
      <div style="text-align: center; padding: 20px;">
        <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
             alt="School Logo" 
             style="width: 100px; height: 100px; margin-bottom: 10px;">
        <h2>${schoolInfo.schoolName || 'Ummu Dhardha Ladies Islamic College'}</h2>
        <p>${schoolInfo.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.'}</p>
        <p>Tel: ${schoolInfo.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${schoolInfo.schoolEmail || 'info@ummudhardha.lk'}</p>
        <hr>
        <h3>Exam Details</h3>
        <div style="margin-top: 20px; text-align: left;">
          <h4>Class: ${exam.class.className}</h4>
          <p>Course: ${exam.course.courseName}</p>
          <p>Type: ${exam?.type?.name}</p>
          <p>Year: ${exam.year}</p>
          <p>Status: ${exam.status === 'draft' ? 'DRAFT' : 'PUBLISHED'}</p>
        </div>
        <table style="${tableStyle}">
          <thead>
            <tr style="${thStyle}">
              <th style="${thStyle}">Subject Code</th>
              <th style="${thStyle}">Subject</th>
              <th style="${thStyle}">Staff</th>
              <th style="${thStyle}">Date</th>
              <th style="${thStyle}">Start Time</th>
              <th style="${thStyle}">End Time</th>
            </tr>
          </thead>
          <tbody>
            ${exam.examDetails.map((detail, index) => `
              <tr key=${detail._id} style="background-color: ${index % 2 === 0 ? '#f2f2f2' : 'white'}">
                <td style="${tdStyle}">${detail.subject.subjectCode}</td>
                <td style="${tdStyle}">${detail.subject.name}</td>
                <td style="${tdStyle}">${detail.teacher ? detail.teacher.name : 'N/A'}</td>
                <td style="${tdStyle}">${dayjs(detail.examDate).format('DD-MM-YYYY')}</td>
                <td style="${tdStyle}">${detail.startTime}</td>
                <td style="${tdStyle}">${detail.endTime}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <p style="margin-top: 20px; text-align: center;">Generated on: ${new Date().toLocaleDateString()}</p>
      </div>
    `;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
    };

    const fetchExam = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${baseURL}/superadmin/exams/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }); // Replace with your actual API endpoint
            setExam(response.data.data);
        } catch (error) {
            console.error('Error fetching exam:', error);
            toast.error('Error fetching exam');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Are you sure you want to delete this exam?')) {
            setLoading(true);
            try {
                await axios.delete(`${baseURL}/superadmin/exams/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    }
                });
                toast.success('Exam deleted successfully!');
                navigate('/'); // Navigate back to exam list
            } catch (error) {
                console.error('Error deleting exam:', error);
                toast.error('Error deleting exam');
            } finally {
                setLoading(false);
            }
        }
    };



    if (loading) {
        return (
            <>
                <Header />
                <Container>
                    <Row>
                        <Col>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Spinner color="primary" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    if (!exam) {
        return (
            <>
                <Header />
                <Container>
                    <Row>
                        <Col>
                            <p>Exam not found.</p>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    return (
        <>
            <Header />
            <Container>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader className="print-hidden" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3>Exam Details</h3>
                                <div>
                                    <Button color="success" size="sm" onClick={generateExamSlip} style={{ marginRight: '10px' }}>
                                        Download
                                    </Button>
                                    <Button color="info" size="sm" onClick={handlePrint} style={{ marginRight: '10px' }}>
                                        Print
                                    </Button>
                                    {/* <Button color="info" size="sm" onClick={handlePrint}>
                                        Print
                                    </Button> */}
                                    <Button color="warning" size="sm" onClick={() => navigate(`/admin/edit-exam/${id}`)}>
                                        Edit
                                    </Button>
                                    <Button color="danger" size="sm" onClick={handleDelete}>
                                        Delete
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody id='print-content'>
                                <div className="exam-info">
                                    <h4>Class: {exam.class.className}</h4>
                                    <p>Course: {exam.course.courseName}</p>
                                    <p>Type: {exam?.type?.name}</p>
                                    <p>Year: {exam.year}</p>
                                    <p>Status: {exam.status === 'draft' ? 'DRAFT' : 'PUBLISHED'}</p>
                                </div>

                                <Table className="table">
                                    <thead>
                                        <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                            <th>Subject Code</th>
                                            <th>Subject</th>
                                            <th>Staff</th>
                                            <th>Date</th>
                                            <th>Start Time</th>
                                            <th>End Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {exam.examDetails.map((detail, index) => (
                                            <tr key={detail._id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                                                <td>{detail.subject.subjectCode}</td>
                                                <td>{detail.subject.name}</td>
                                                <td>{detail.teacher ? detail.teacher.name : 'N/A'}</td>
                                                <td>{dayjs(detail.examDate).format('DD-MM-YYYY')}</td>
                                                <td>{detail.startTime}</td>
                                                <td>{detail.endTime}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="print-only">
                    <Col>
                        <div className="exam-info">
                            <h4>Class: {exam.class.className}</h4>
                            <p>Course: {exam.course.courseName}</p>
                            <p>Type: {exam?.type?.name}</p>
                            <p>Year: {exam.year}</p>
                            <p>Status: {exam.status}</p>
                        </div>
                        <Table className="table">
                            <thead>
                                <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                    <th>Subject Code</th>
                                    <th>Subject</th>
                                    <th>Staff</th>
                                    <th>Date</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {exam.examDetails.map((detail, index) => (
                                    <tr key={detail._id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                                        <td>{detail.subject.subjectCode}</td>
                                        <td>{detail.subject.name}</td>
                                        <td>{detail.teacher ? detail.teacher.name : 'N/A'}</td>
                                        <td>{dayjs(detail.examDate).format('DD-MM-YYYY')}</td>
                                        <td>{detail.startTime}</td>
                                        <td>{detail.endTime}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Footer />
            </Container>
        </>
    );
}

export default ViewExam;
